/** Reads a display name from a Contentful reference, string or array of either. */
const nameOf = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(nameOf).join(',');
    return value.fields?.name || value.fields?.title || value.name || value.title || '';
};

/**
 * Tender notices and archived items are stored in the same `events` content
 * type as news, so news listings have to exclude them explicitly.
 */
export const isNewsItem = (entry) => {
    const haystack = `${nameOf(entry?.fields?.collection)},${nameOf(entry?.fields?.category)}`;
    return !haystack.includes('Archive') && !haystack.includes('Tender');
};

/** Label for a news item, taken from the CMS rather than inferred. */
export const eventCategory = (entry) => nameOf(entry?.fields?.category).split(',')[0] || '';

export default isNewsItem;
